import {Injectable} from '@angular/core';
import {IRecuperationListeDonneesMetier} from '@app/core/interfaces';
import {Observable} from 'rxjs';
import {Autowired} from '@angular-ru/autowired';
import {ListAffectionPrescriptionTableListeRestApiService} from './list-affection-prescription-table.liste.rest-api.service';

@Injectable({providedIn: 'root'})
export class ListAffectionPrescriptionTableListeMetierService implements IRecuperationListeDonneesMetier {
  @Autowired() restApi: ListAffectionPrescriptionTableListeRestApiService;

  requeteRecuperationListeDonnees(data: any, args?: any): Observable<any> | Promise<any> | any {
    // console.log('data : ', data);
    // console.log('args : ', args);

    return this.restApi.requeteRecuperationListeDonnees(data, args);
  }
}
